// @ts-nocheck
import { DashboardLayout } from "./Dashboard";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Plus, Search, Building2, Edit, Eye, UserRound, User } from "lucide-react";
import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { toast } from "sonner";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useAuth } from "@/contexts/use-auth";
import { useOrg } from "@/contexts/useOrg";
import Organizations from "./Organizations";
import AxiosInstance from "@/utils/AxiosInstance";
import { useGetData } from "@/hooks/useGetData";
import LoaderWrapper from "./LoaderWrapper";
import { HorizontalCardShimmer } from "@/components/Shimmer";
import { useDebouncedInput } from "@/hooks/useDebouncedInput";
import {
  getErrToast,
  getNpiDataForProviders,
  getPromise,
  getPromiseToast,
} from "@/utils/helpers";
import {
  capitalizeTheStartingCharacterFilter,
  PERSON_CAPITALIZE_FIELDS,
} from "@/constants/payloadFilters";
import RHFWrapper from "@/components/RHFWrapper";
import CommonFormFields from "@/components/CommonFormFields";
import MyDialogContent from "@/components/MyDialogContent";
import RhfSelect from "@/components/rhfFields/RhfSelect";
import Grid from "@/components/Grid";
import { useFormContext, useWatch } from "react-hook-form";
import RhfInput from "@/components/rhfFields/RhfInput";
import * as yup from "yup";
import { CommonFieldSchema, ProviderSchema } from "@/utils/ValidataionSchemas";
import RhfMultiInput from "@/components/rhfFields/RhfMultiInput";
import NpiSearch from "@/components/NpiSearch";
import MyTable, { ColumnHeader, RowData } from "@/components/MyTable";
import DataTable from "@/components/MyTable";
import TableWithSearch from "@/components/TableWithSearch";
import { ProviderTableHeaders } from "@/utils/tablesData";
import { useLocation, useNavigate } from "react-router";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import Practitioners from "./Practitioners";

// ✅ Dummy Data for now (replace with API later)

export default function Providers() {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [selectedProvider, setSelectedProvider] = useState<any>(null);
  const [isViewDialogOpen, setIsViewDialogOpen] = useState(false);
  // const [selectedOrgId, setSelectedOrgId] = useState<string | null>("org1");
  const { user, isAuthorized } = useAuth();

  return (
    <>
      <ProvidersContent
        isDialogOpen={isDialogOpen}
        setIsDialogOpen={setIsDialogOpen}
        currentUser={user}
        selectedProvider={selectedProvider}
        setSelectedProvider={setSelectedProvider}
        isViewDialogOpen={isViewDialogOpen}
        setIsViewDialogOpen={setIsViewDialogOpen}
        isAuthorized={isAuthorized}
      />
    </>
  );
}

function ProvidersContent({
  // search,
  // setSearch,
  isDialogOpen,
  setIsDialogOpen,

  currentUser,
  selectedProvider,
  setSelectedProvider,
  isViewDialogOpen,
  setIsViewDialogOpen,
  isAuthorized,
}: {
  // search: string;
  // setSearch: (value: string) => void;
  isDialogOpen: boolean;
  setIsDialogOpen: (value: boolean) => void;

  currentUser: any;
  selectedProvider: any;
  setSelectedProvider: (value: any) => void;
  isViewDialogOpen: boolean;
  setIsViewDialogOpen: (value: boolean) => void;
  isAuthorized: (permission: string) => boolean;
}) {
  const {
    input: search,
    setInput: setSearch,
    debouncedInput,
  } = useDebouncedInput("", 500);
  const {
    selectedOrganizations: organizations,
    isAllSelected,
    selectedOrgId: selectedOrg,
    allFacilities: facilities,
  } = useOrg();
  const [selectedOrgId, setSelectedOrgId] = useState(null);
  const [selectedFacilityId, setSelectedFacilityId] = useState(null);
  const [btnloading, setBtnLoading] = useState(false);
  const [addPractionDialog, setIsAddPracDialog] = useState(false);
  const nav = useNavigate();
  const {pathname} = useLocation()
  const [view, setView] = useState(pathname.includes("/practitioners") ?  "practitioners" : "providers");
  const [clinicalType, setClinicalType] = useState(false);

  // Update view when pathname changes (e.g., when navigating from organization profile)
  useEffect(() => {
    if (pathname.includes("/practitioners")) {
      setView("practitioners");
    } else if (pathname.includes("/providers")) {
      setView("providers");
    }
  }, [pathname]);

  const [providers, setProviders] = useState([]);

  // 🚀 Replace with real API call later
  const handleCreateProvider = async (formData, methods) => {
    const { pr, rejectFn, resolveFn } = getPromise();
    getPromiseToast(pr);

    const newProvider = {
      firstName: formData?.firstName,
      middleName: formData?.middleName,
      lastName: formData?.lastName,
      dateOfBirth: formData?.dateOfBirth,
      email: formData?.email,
      phone: formData?.phone,
      street: formData?.street,
      city: formData?.city,
      state: formData?.state,
      zipcode: formData?.zipcode,
      gender: formData?.gender,
      status: formData?.status,
      timezone: formData?.timezone,
      organizationId: formData?.organizationId,
      // facilityId: formData?.facilityId,

      npiNumber: formData?.npiNumber,
      specializations: formData?.specializations,
      taxonomies: formData?.taxonomies,
    };
    console.log("POST PROVIDER", newProvider);
    try {
      setBtnLoading(true);
      const { data }: { data: any } = await AxiosInstance().post(
        "/providers",
        capitalizeTheStartingCharacterFilter(
          newProvider,
          PERSON_CAPITALIZE_FIELDS,
        ),
      );
      setProviders((prev) => [data?.data, ...prev]);
      resolveFn("Provider added successfully");

      setIsDialogOpen(false);
    } catch (error: any) {
      rejectFn(error);
      if (methods) {
        if (
          error?.response?.data?.message.includes("email") &&
          error?.response?.data?.message.includes("exist")
        )
          methods.setError("email", {
            message: 'Email Already Exists',
          });

        if (
          error?.response?.data?.message.includes("phone") &&
          error?.response?.data?.message.includes("exist")
        )
          methods.setError("phone", {
            message: 'Phone Number Already Exists',
          });
      }
    } finally {
      setBtnLoading(false);
    }
  };

  // 🚀 Replace with real API call later
  const handleUpdateProvider = async (formData, methods) => {
    const { pr, rejectFn, resolveFn } = getPromise();
    getPromiseToast(pr);
    try {
      setBtnLoading(true);

      if (!selectedProvider) return;

      const updatedProvider = {
        firstName: formData?.firstName,
        middleName: formData?.middleName,
        lastName: formData?.lastName,
        dateOfBirth: formData?.dateOfBirth,
        email: formData?.email,
        phone: formData?.phone,
        street: formData?.street,
        city: formData?.city,
        state: formData?.state,
        zipcode: formData?.zipcode,
        gender: formData?.gender,
        status: formData?.status,
        timezone: formData?.timezone,
        organizationId: formData?.organizationId,
        // facilityId: formData?.facilityId,
        specializations: formData?.specializations,
        taxonomies: formData?.taxonomies,
        npiNumber: formData?.npiNumber,
      };
      console.log("PUT PROVIDER", {
        ...updatedProvider,
        _id: selectedProvider?._id,
      });

      const { data } = await AxiosInstance().put(
        "/providers/" + selectedProvider?._id,
        capitalizeTheStartingCharacterFilter(
          updatedProvider,
          PERSON_CAPITALIZE_FIELDS,
        ),
      );
      setProviders((prev) =>
        prev.map((p) =>
          p._id === selectedProvider._id
            ? {
                ...selectedProvider,
                ...updatedProvider,
              }
            : p,
        ),
      );

      resolveFn("Provider updated successfully");
      setIsViewDialogOpen(false);
      methods && methods.setError("email", "Already exists");
      setSelectedProvider(null);
    } catch (error) {
      rejectFn(error);
    } finally {
      setBtnLoading(false);
    }
  };

  const handleViewProvider = (provider: any) => {
    setSelectedProvider(provider);
    setIsViewDialogOpen(true);
  };

  return (
    <>
      <DashboardLayout
        activePage="/providers"
        rightcomponent={
          <>
            {isAuthorized("canAddViewProviders") && (
              // <DialogTrigger asChild>
                  <Button onClick={()=> setClinicalType(true)} className="w-auto">
                    <Plus className="w-4 h-4 mr-1" />
                     Clinician
                  </Button>
                // {/* </DialogTrigger> */}
            )}
             {/* {isAuthorized("canAddPractitioners") && (
          <Dialog open={isDialogOpen} onOpenChange={handleDialogOpenChange}>
            <DialogTrigger asChild>
              <Button
                className="w-full sm:w-auto"
                disabled={!hasProvidersAvailable}
                title={!hasProvidersAvailable ? "No providers available" : ""}
              >
                {hasProvidersAvailable && <Plus className="w-4 h-4 mr-2" />}
                {providerLoading
                  ? "Loading ..."
                  : hasProvidersAvailable
                    ? "Add Practitioner"
                    : "No Provider"}
              </Button>
            </DialogTrigger>

            <MyDialogContent heading="Add New Practitioner">
              <PractitionerForm
                key={`new${isDialogOpen}`}
              // key={}
                btnloading={btnLoading}
                className={"space-y-6"}
                facilities={[]}
                isEdit={false}
                defaultValues={{}}
                onClose={() => handleDialogOpenChange(false)}
                organizations={organizations}
                providers={providers}
                onSubmit={handleCreatePractitioner}
              />
            </MyDialogContent>
          </Dialog>
        )} */}
          </>
        }
      >
        <ToggleGroup
          type="single"
          value={view}
          onValueChange={(value) => {
            if (value) setView(value);
            setIsAddPracDialog(false);
            setIsDialogOpen(false);
            nav(`/${value}`)
          }}
          className="mb-4 w-full"
        >
          <ToggleGroupItem
            value="providers"
            aria-label="providers"
            className={`px-6 py-2 text-sm font-medium flex-1 md:flex-none teachers ${view === "providers" ? "bg-primary text-white" : ""}`}
             style={{
              backgroundColor :view === "providers"? "#3463AA" : "#EEEEEE"
            }}
          >
          <User/>  Providers
          </ToggleGroupItem>
          <ToggleGroupItem
            value="practitioners"
            aria-label="practitioners"
            className={`px-6 py-2 text-sm font-medium flex-1 md:flex-none teachers ${view === "practitioners" ? "bg-primary text-white" : ""}`}
             style={{
              backgroundColor :view === "practitioners"? "#3463AA" : "#EEEEEE"
            }}
          >
            <User/> Practitioners
          </ToggleGroupItem>
        </ToggleGroup>

        {/* Dialog/Model */}
   <Dialog open={clinicalType} onOpenChange={setClinicalType}>
        <DialogContent className="sm:max-w-[500px]">
          <DialogHeader>
            <DialogTitle className="text-2xl font-semibold">Select User Type</DialogTitle>
            <DialogDescription>
              Choose the type of Clinician user you want to add to your system
            </DialogDescription>
          </DialogHeader>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 py-6">
            {/* Provider Card */}
            <button
              onClick={() => {
                setClinicalType(false);
                if (view === "practitioners") {
                  setView("providers");
                  nav("/providers");
                }
                setIsDialogOpen(true);
              }}
              className="group relative overflow-hidden rounded-lg border-2 border-gray-200 bg-white p-6 text-left transition-all hover:border-blue-500 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
            >
              <div className="flex flex-col items-center space-y-4">
                <div className="rounded-full bg-blue-100 p-4 transition-colors group-hover:bg-blue-500">
                  <Building2 className="h-8 w-8 text-blue-600 transition-colors group-hover:text-white" />
                </div>
                <div className="text-center">
                  <h3 className="font-semibold text-lg text-gray-900">Provider</h3>
                  <p className="mt-1 text-sm text-gray-500">Add primary doctor or healthcare provider</p>
                </div>
              </div>
            </button>

            {/* Practitioner Card */}
            <button
              onClick={() => {
                setClinicalType(false);
                if (view === "providers") {
                  setView("practitioners");
                  nav("/practitioners");
                }
                setIsAddPracDialog(true);
              }}
              className="group relative overflow-hidden rounded-lg border-2 border-gray-200 bg-white p-6 text-left transition-all hover:border-green-500 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-offset-2"
            >
              <div className="flex flex-col items-center space-y-4">
                <div className="rounded-full bg-green-100 p-4 transition-colors group-hover:bg-green-500">
                  <UserRound className="h-8 w-8 text-green-600 transition-colors group-hover:text-white" />
                </div>
                <div className="text-center">
                  <h3 className="font-semibold text-lg text-gray-900">Practitioner</h3>
                  <p className="mt-1 text-sm text-gray-500">Add practitioner under a provider</p>
                </div>
              </div>
            </button>
          </div>
        </DialogContent>
      </Dialog>
        {view === "providers" && (
          <div className="">
           
           
            <TableWithSearch
              fetchCondition={!!selectedOrg}
              heading="Providers List"
              isIncludeSearch
              clickRow={() => {}}
              columnPreferenceKey="providers-list"
              apiDataKey="providers"
              columnHeaders={ProviderTableHeaders}
              searchPlaceholder="Search providers"
              url="/providers"
              params={{
                ...(selectedOrg && !isAllSelected
                  ? { orgId: selectedOrg }
                  : {}),
              }}
              viewData={providers.map((v) => ({
                ...v,
                firstName: `${v?.firstName || ""} ${v?.middleName || ""} ${v?.lastName || ""}`,
                address: [v?.street, v?.city, v?.state, v?.zipcode]
                  .map((part) => String(part ?? "").trim())
                  .filter(Boolean)
                  .join(", "),
                organizationId: organizations.find(
                  (org) => org?._id == v?.organizationId,
                )?.organizationName,
              }))}
              data={providers}
              isHideSelect
              setData={setProviders}
              isActionColumn
              handleAction={(data) => {
                handleViewProvider(data);
              }}
              // clickRow={(data:any)=> nav(data?._id, {state: {data}})}
              moreActions={[
                {
                  label: "View ",
                  icon: <Eye />,
                  isShow: () => true,
                  onClick: (data) => nav(data?._id, { state: { data } }),
                },
              ]}
              isColumnSelection
            />
          </div>
        )}

       {view === "practitioners" && (
         <Practitioners isView={view === "practitioners"} isDialogOpen={addPractionDialog} setIsDialogOpen={setIsAddPracDialog} providers={providers} setProviders={setProviders} />
       )}

       {/* provider dialogs */}
        <Dialog
              open={isViewDialogOpen}
              onOpenChange={(open) => {
                if (open) {
                  setIsViewDialogOpen(open);
                } else {
                  setIsViewDialogOpen(open);
                  setSelectedProvider(null);
                }
              }}
            >
              <MyDialogContent heading="Provider Details" className="px-4">
                {selectedProvider && (
                  <ProviderForm
                    key={selectedProvider?._id}
                    btnloading={btnloading}
                    className={"space-y-6"}
                    defaultValues={selectedProvider}
                    isEdit={true}
                    onClose={() => {
                      setIsViewDialogOpen(false);
                      setSelectedProvider(null);
                    }}
                    onSubmit={handleUpdateProvider}
                    organizations={organizations}
                  />
                )}
              </MyDialogContent>
            </Dialog>
             <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
                {/* <DialogTrigger asChild>
                  <Button className="w-full sm:w-auto">
                    <Plus className="w-4 h-4 mr-2" />
                    Add Provider
                  </Button>
                </DialogTrigger> */}

                <MyDialogContent heading="Add New Provider">
                  <ProviderForm
                    key={`new${isDialogOpen}`}
                    btnloading={btnloading}
                    className={"space-y-6"}
                    defaultValues={{
                      ...(selectedOrg
                        ? { organizationId: selectedOrg }
                        : Array.isArray(organizations) &&
                          organizations.length == 1
                        ? { organizationId: organizations?.[0]?._id }
                        : {}),
                    }}
                    isEdit={false}
                    onClose={() => setIsDialogOpen(false)}
                    onSubmit={handleCreateProvider}
                    organizations={organizations}
                  />
                </MyDialogContent>
              </Dialog>

      </DashboardLayout>
    </>
  );
}

export const ProviderForm = React.memo(
  ({
    isEdit,
    btnloading,
    defaultValues = {},
    organizations,
    onSubmit,
    onClose,
    className,
  }: any) => {
    const [npidefaultValues, setNpiDefaultValues] = useState({
      ...defaultValues,
      organizationId: defaultValues?.organizationId === 'anthro-care' ? null : defaultValues?.organizationId,
    });
    console.log({
      isEdit,
      btnloading,
      defaultValues,
      organizations,
      onSubmit,
      onClose,
      className,
    });
    // console.log({ defaultValues, npidefaultValues });
    return (
      <RHFWrapper
        isValidate={true}
        validateSchema={yup.object({ ...CommonFieldSchema, ...ProviderSchema })}
        className={className}
        onSubmit={onSubmit}
        initialValues={npidefaultValues}
      >
        {/* <NpiSearch
          getValues={(values) => {
            const prefildata = getNpiDataForProviders(
              values?.data?.details?.results?.[0],
              organizations,
            );
            console.log("PREFIL VALUES", values, prefildata);
            setNpiDefaultValues((p) => ({ ...p, ...prefildata }));
          }}
        /> */}
        <CommonFormFields defaultValues={{}} isEdit={true} />
        <Grid count={{sm:1, md:2}}>
          <RhfSelect
            label="Organization"
            required={true}
            name="organizationId"
            defaultvalue={npidefaultValues?.organizationId ?? ""}
            disabled={
              Array.isArray(organizations) ? organizations.length == 1 : true
            }
            options={
              Array.isArray(organizations)
                ? organizations.map((org) => ({
                    label: org.organizationName,
                    value: org?._id,
                  }))
                : []
            }
            placeholder={
              !organizations ||
              (Array.isArray(organizations) && organizations.length == 0)
                ? "No organizations available"
                : null
            }
          />
          {/* <FacilitySelect
          defaultvalue={defaultValues?.facilityId ?? ""}
          organizations={organizations}
        /> */}
          <RhfInput
            name="npiNumber"
            label="NPI Number"
            required
            isNumber
            maxLength={10}
            // defaultvalue={defaultValues?.npiNumber ?? ""}
          />
        </Grid>

        <div>
          <RhfMultiInput
            name="specializations"
            label="Specializations"
            required={true}
          />
        </div>
        <div>
          <RhfMultiInput name="taxonomies" label="Taxonomies" required={true} />
        </div>

        <div className="flex justify-end gap-3 pt-2 sticky bottom-0 w-full bg-white">
          <Button type="button" variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button type="submit" disabled={btnloading}>
            {isEdit ? "Update" : "Add"} Provider
          </Button>
        </div>
      </RHFWrapper>
    );
  },
);

const FacilitySelect = ({ organizations }) => {
  // const orgId = useWatch({ name: "organizationId" });
  const { watch } = useFormContext();
  const orgId = watch("organizationId");
  // console.log({orgId})
  let facilitiesOptions = [];
  if (orgId) {
    facilitiesOptions = (
      organizations?.find((o) => o._id == orgId)?.facilities || []
    ).map((fac) => ({ label: fac?.name, value: fac?._id }));
  }

  return (
    <RhfSelect
      label="Facility"
      required={true}
      name="facilityId"
      placeholder={orgId ? "Select facility" : "Select organization first"}
      options={facilitiesOptions}
      disabled={!orgId}
    />
  );
};
